import { isDefectOverdue } from "@/lib/dateUtils";
import { cn } from "@/lib/utils";
import type { DefectCardData } from "./DefectCard.types";

export function useDefectCardState(defect: DefectCardData, selected: boolean) {
  const isOverdue = isDefectOverdue(defect.due_date, defect.status);

  const cardClassName = cn(
    "group transition-all duration-200",
    // Tonal-Hover (DS 4) darf den Overdue-Tint nicht ueberschreiben; bei overdue vertieft der Hover den Rot-Ton.
    isOverdue
      ? "border-destructive bg-destructive/5 hover:bg-destructive/10"
      : "hover:bg-surface-container-low",
    selected && "ring-2 ring-primary",
    defect.isOfflinePending && "border-dashed border-muted-foreground/40 opacity-80",
  );

  return {
    isOverdue,
    cardClassName,
  };
}
